/**
 * Platform Selector - Tabs für Plattform-Auswahl
 */

import { Package, Truck, ShoppingCart, Building, Store, Settings } from 'lucide-react';
import type { PlatformId } from '@/types/price-calculator';
import { PLATFORM_PRESETS } from '@/lib/price-calculator';
import { cn } from '@/lib/utils';

const PLATFORM_ICONS: Record<string, React.ElementType> = {
  Package,
  Truck,
  Gavel: ShoppingCart,
  Building,
  ShoppingCart,
  Store,
  Settings,
};

interface PlatformSelectorProps {
  selected: PlatformId;
  onSelect: (id: PlatformId) => void;
}

export function PlatformSelector({ selected, onSelect }: PlatformSelectorProps) {
  const platforms = Object.values(PLATFORM_PRESETS);

  return (
    <div className="flex flex-wrap gap-2">
      {platforms.map((platform) => {
        const Icon = PLATFORM_ICONS[platform.icon] || Package;
        const isActive = selected === platform.id;

        return (
          <button
            key={platform.id}
            onClick={() => onSelect(platform.id)}
            className={cn(
              'flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all',
              isActive
                ? 'bg-primary-600 text-white shadow-md'
                : 'bg-white dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700 border border-neutral-200 dark:border-neutral-700'
            )}
          >
            <Icon className="h-4 w-4" />
            <span className="hidden sm:inline">{platform.name}</span>
          </button>
        );
      })}
    </div>
  );
}
